import { Field } from '../../util/components/resource/resource-fields';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';

@Endpoint('message-channels', 'MessageChannel')
export class MessageChannel extends ApiResource<MessageChannel> {
  @Field()
  slackId!: string;

  @Field()
  name!: string;
}
